module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAUCAYAAACqJ5zlAAAABHNCSVQICAgIfAhkiAAAABhJREFUGJVj/P///38GJMDEgAZGBUgVAABc6QQkloZEswAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/static/footerBack.png
// module id = gNxm
// module chunks = 46